import React from "react";
import Button from "@material-ui/core/Button";
import Field from "../../Field";

export default class TableSearch extends React.Component {
  handleSearchChange = async ({value}) => {
    if (!value) {
      await this.handleSearchClear();
    }
    this.props.onQueryChange({
      $or: this.props.searchFields.map(field => {
        return {[field]: {$regex: value}};
      })
    });
  };
  handleSearchClear = async () => {
    await this.props.onQueryChange({$or: undefined});
    this.props.onSubmit();
  };
  handleSubmit = event => {
    event.preventDefault();
    this.props.onSubmit();
  };
  render() {
    const {value, disabled} = this.props;

    return (
      <form onSubmit={this.handleSubmit} style={{width: "90%", textAlign: "right", display: "flex"}}>
        <div style={{flexBasis: "50%"}}>
          <Field name="searchText" value={value} onChange={this.handleSearchChange} placeholder="Search" />
        </div>
        <Button
          variant="contained"
          style={{maxHeight: "36px"}} // fix for some css issue in MaterialUI
          type="submit"
          disabled={disabled}>
          Search
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/TableSearch/index.jsx